<template>
  <footer class="landing-footer">
    <div class="landing-container">
      <div class="landing-footer__grid">
        <div>
          <router-link to="/" class="landing-nav__logo landing-nav__logo--footer">
            <img src="@/assets/logo.svg" alt="MentorMe" class="landing-nav__logo-img" />
          </router-link>
          <p style="font-size: 13.5px; color: rgba(255, 255, 255, 0.5); line-height: 1.7; max-width: 260px; margin-bottom: 18px">
            EdTech-платформа для поступления в зарубежные вузы. Помогаем казахстанским студентам учиться за рубежом.
          </p>
          <div class="landing-footer__social">
            <a href="https://www.youtube.com/@mentorme_kz" target="_blank" rel="noopener" class="landing-footer__social-link" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 00.5 6.2 31 31 0 000 12a31 31 0 00.5 5.8 3 3 0 002.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 002.1-2.1A31 31 0 0024 12a31 31 0 00-.5-5.8zM9.6 15.6V8.4l6.2 3.6z" /></svg>
            </a>
            <a href="https://wa.link/j54bc7" target="_blank" rel="noopener" class="landing-footer__social-link" aria-label="WhatsApp">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.8 14.01c-.24.68-1.42 1.31-1.96 1.36-.5.05-1.13.07-1.83-.11-.42-.13-.96-.31-1.66-.61-2.92-1.26-4.83-4.2-4.98-4.4-.15-.2-1.19-1.58-1.19-3.02s.76-2.13 1.03-2.42c.27-.29.59-.37.79-.37.2 0 .4 0 .57.01.18.01.43-.07.67.51.24.59.83 2.03.9 2.18.07.15.12.32.02.52-.34.69-.7.66-.36.97-.27.27-.57.56-.27.27-.57.56-.27.27-.57.56l-.13.14c-.15.15-.3.31-.13.6.17.29.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.35 1.46.29.15.46.12.63-.07.17-.2.73-.85.92-1.14.2-.29.39-.24.66-.15.27.1 1.71.81 2 .96.29.15.49.22.56.34.07.13.07.73-.17 1.41z" /></svg>
            </a>
            <a href="https://www.instagram.com/mentorme_kz" target="_blank" rel="noopener" class="landing-footer__social-link" aria-label="Instagram">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none" /></svg>
            </a>
          </div>
        </div>

        <div>
          <div style="font-size: 11px; font-weight: 800; color: rgba(255, 255, 255, 0.35); text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 16px">Платформа</div>
          <div style="display: flex; flex-direction: column; gap: 10px">
            <router-link v-for="link in platformLinks" :key="link.to" :to="link.to" class="landing-footer__link">{{ link.label }}</router-link>
          </div>
        </div>

        <div>
          <div style="font-size: 11px; font-weight: 800; color: rgba(255, 255, 255, 0.35); text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 16px">Компания</div>
          <div style="display: flex; flex-direction: column; gap: 10px">
            <a v-for="item in companyLinks" :key="item" href="#" class="landing-footer__link">{{ item }}</a>
          </div>
        </div>

        <div>
          <div style="font-size: 11px; font-weight: 800; color: rgba(255, 255, 255, 0.35); text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 16px">Контакты</div>
          <div style="display: flex; flex-direction: column; gap: 12px">
            <div style="display: flex; gap: 10px; align-items: flex-start">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" style="flex-shrink: 0; margin-top: 2px" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
              <span style="font-size: 13px; color: rgba(255, 255, 255, 0.55); line-height: 1.5">Алматы, ул. Гагарина 124, 050000</span>
            </div>
            <a href="mailto:info@mentorme.kz" style="display: flex; gap: 10px; align-items: center" class="landing-footer__link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" style="flex-shrink: 0" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,12 2,6" /></svg>
              <span>info@mentorme.kz</span>
            </a>
            <a href="tel:+77007187878" style="display: flex; gap: 10px; align-items: center" class="landing-footer__link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" style="flex-shrink: 0" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>
              <span>+7 700 718 78 78</span>
            </a>
          </div>
        </div>
      </div>

      <div class="landing-footer__bottom">
        <p style="font-size: 12px; color: rgba(255, 255, 255, 0.3)">© 2026 MentorMe AI Tech. Все права защищены. · Свидетельство №16003 от 15.02.2025</p>
        <div style="display: flex; gap: 24px; align-items: center; flex-wrap: wrap">
          <a href="#" style="font-size: 12px; color: rgba(255, 255, 255, 0.3)" class="landing-footer__muted-link">Политика конфиденциальности</a>
          <div style="display: flex; gap: 12px">
            <a href="#" style="font-size: 12px; color: #fff; font-weight: 700">RU</a>
            <a href="#" style="font-size: 12px; color: rgba(255, 255, 255, 0.3)" class="landing-footer__muted-link">KZ</a>
            <a href="#" style="font-size: 12px; color: rgba(255, 255, 255, 0.3)" class="landing-footer__muted-link">EN</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LandingFooter',
  data() {
    return {
      platformLinks: [
        { to: '/login', label: 'Поиск программ' },
        { to: '/login', label: 'Болашак и гранты' },
        { to: '/login', label: 'Языковая школа' },
        { to: '/login', label: 'Полезное' },
      ],
      companyLinks: ['О нас', 'Наши услуги', 'СМИ о нас', 'Карьера'],
    };
  },
};
</script>

<style scoped>
.landing-footer__link {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 500;
  transition: color 0.12s;
}

.landing-footer__link:hover {
  color: #fff;
}

.landing-footer__muted-link:hover {
  color: rgba(255, 255, 255, 0.6) !important;
}
</style>
